// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.bitget.web3",
    name: "Bitget Wallet",
    homepage: "https://web3.bitget.com",
    image_id: "68e8063a-ff69-4941-3b40-af09e2fcd700",
    app: {
        browser: "https://bitkeep.com",
        ios: "https://web3.bitget.com/en/wallet-download?type=0",
        android: "https://web3.bitget.com/en/wallet-download?type=0",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chrome.google.com/webstore/detail/bitkeep-crypto-nft-wallet/jiidiaalihmmhddjgbnbgdfflelocpak",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "bitkeep://",
        universal: "https://bkapp.vip",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map